/**
 * IMPORTANT!
 * As a file intended for "common" Pixi-related types that are shared between '/src/' and '/cypress/',
 * it's important to not import anything additional here that may inadvertently evaluate Jest and/or Cypress
 * library typings that could then conflict and potentially be difficult to debug.
 */
import { shallowEqual } from 'react-redux';
function pixiObjectMatches(pixiObject, requiredPixiObjectData) {
    const existingPixiObjectData = pixiObject['pixi-data'];
    if (!existingPixiObjectData) {
        return false;
    }
    // Ensure every required field is in the provided pixi-data object (shallow equality),
    // and also fall back to checking fields on the parent object (which is managed by pixi.js) for a match,
    // such as _text which contains the rendered text but is not present in the pixi-data object.
    return Object.entries(requiredPixiObjectData).every(([requiredKey, requiredValue]) => shallowEqual(existingPixiObjectData[requiredKey], requiredValue) ||
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        shallowEqual(pixiObject[requiredKey], requiredValue));
}
export function findPixiObject(currentPixiObject, requiredPixiObjectData) {
    if (!currentPixiObject) {
        return null;
    }
    if (pixiObjectMatches(currentPixiObject, requiredPixiObjectData)) {
        return currentPixiObject;
    }
    if (!currentPixiObject.children) {
        // currentPixiObject is likely of type PIXI.DisplayObject
        return null;
    }
    for (let i = 0; i < currentPixiObject.children.length; i++) {
        // recursion
        const childPixiObject = findPixiObject(currentPixiObject.children[i], requiredPixiObjectData);
        if (childPixiObject) {
            return childPixiObject;
        }
    }
    return null;
}
